import { useState, useEffect } from "react";
import { Location } from "history";
import { FormattedMessage } from "react-intl";
import { User } from "firebase/auth";
import { isPlatform } from "@ionic/core";

import Auth from "../../api/auth";
import { useAppStore } from "../../store/app";
import { useAuth } from "../../providers/auth";
import GoogleAuthButton from "../../components/common/google-auth";

import styles from "./styles.module.css";
import "./login.css";
import PasswordAuth from "../../components/common/password-auth";
import Divider from "./Divider";
// import MicrosoftAuthButton from "../../components/common/microsoft-auth";

const isMobile = isPlatform("android") || isPlatform("ios");

interface Error {
  message: string;
}

const Register: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const [logInError, setLogInError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [registerLink, setRegisterLInk] = useState("");
  const language = useAppStore((state) => state.user.language);
  const { refreshUser } = useAuth();

  useEffect(() => {
    const { search } = props.location;
    setRegisterLInk(`/auth/login${search}`);
  }, [props.location]);

  const registerApi = async (
    auth: User,
    type?: "password" | "google" | "microsoft",
    autoLogin?: boolean,
  ) => {
    setLoading(() => true);
    const hash = await auth.getIdToken();
    console.log(
      "Register API called with auth:",
      auth,
      "type:",
      type,
      "autoLogin:",
      autoLogin,
    );
    const { data, err } = autoLogin
      ? await Auth.login({ hash })
      : await Auth.register({
          email: auth.email,
          language,
          auth: {
            provider: type || "password",
            uid: auth.uid,
          },
        });

    if (data && !autoLogin) {
      // is a registration without auto-login
      refreshUser(); // refetch user after registration in DB succeded
    }
    if (err) {
      let message = err.message;
      if (err.details && err.details.body && err.details.body.length) {
        err.details.body.forEach((e: Error) => {
          message = message + " " + e.message;
        });
      }
      // Delete the user from firebase if somehting went wrong
      await auth?.delete();
      setLogInError(() => message);
    }
    setLoading(() => false);
  };

  return (
    <div className={styles.authHolder}>
      <div className={styles.authPanel}>
        <div className="flex flex-column gap-2 mb-4">
          <h1 className="mb-0">
            <FormattedMessage
              id={isMobile ? "auth.title" : "auth.register.title"}
            />
          </h1>
          {isMobile && (
            <h2 className="color-step-700 fs-3 mb-0 text-center">
              <FormattedMessage
                id={isMobile ? "auth.description.mobile" : "auth.description"}
              />
            </h2>
          )}
        </div>

        <div className="flex flex-column gap-3">
          <GoogleAuthButton type="sign-up" onSuccess={registerApi} />
          {/*
          <MicrosoftAuthButton
            type="sign-up"
            onSuccess={registerApi}
          />
          */}
        </div>

        <Divider />

        <PasswordAuth
          type="sign-up"
          loading={loading}
          registerLink={registerLink}
          error={logInError}
          onSuccess={registerApi}
        />
      </div>
    </div>
  );
};

interface ILayoutProps {
  location: Location;
}

export default Register;
